import React, { Component } from 'react';
import { restRequest } from '../../../../../Helpers/RequestHelper';
import Loader from './../../../../../Components/Loader/Loader';
import Dropdown from './../../../../../Components/Dropdown/CustomDropdown';
import TransactionsTable from './TransactionsTable';
import './ItemTransaction.css';
import EmptyTable from '../../../../../Components/ListTable/EmptyTable';
import { checkError } from '../../../../../Helpers/AuthHelper';
import { SmallLoader } from '../../../../../Components';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
class ItemTransactionTab extends Component {
  transactionTable = {
    sales_orders: {
      tableHeaders: [
        t(`Items.transaction_tab_options.date`),
        t(`Items.transaction_tab_options.order_no`),
        t(`Items.transaction_tab_options.customer`),
        t(`Items.transaction_tab_options.qty`),
        t(`Items.transaction_tab_options.total`),
        t(`Items.transaction_tab_options.status`),
      ],

      tableData: [
        'order_date',
        'sales_order_no',
        'display_name',
        'quantity',
        'total',
        'status',
      ],
      rightAlignColumns: [4, 5, 6],
      linkTo: { path: '/salesorders/', linkedColumn: 'sales_order_no' },
    },
    invoices: {
      tableHeaders: [
        t(`Items.transaction_tab_options.date`),
        t(`Items.transaction_tab_options.invoice_no`),
        t(`Items.transaction_tab_options.customer`),
        t(`Items.transaction_tab_options.qty`),
        t(`Items.transaction_tab_options.amount`),
        t(`Items.transaction_tab_options.status`),
      ],
      tableData: [
        'invoice_date',
        'invoice_no',
        'customer_name',
        'quantity',
        'total',
        'status',
      ],
      rightAlignColumns: [4, 5, 6],
      linkTo: { path: '/invoices/', linkedColumn: 'invoice_no' },
    },
    purchase_orders: {
      tableHeaders: [
        t(`Items.transaction_tab_options.date`),
        t(`Items.transaction_tab_options.order_no`),
        t(`Items.transaction_tab_options.vendor`),
        t(`Items.transaction_tab_options.qty`),
        t(`Items.transaction_tab_options.total`),
        t(`Items.transaction_tab_options.status`),
      ],
      tableData: [
        'order_date',
        'purchase_order_no',
        'vendor_name',
        'quantity',
        'total',
        'status',
      ],
      rightAlignColumns: [4, 5, 6],
      linkTo: { path: '/purchaseorders/', linkedColumn: 'purchase_order_no' },
    },
    bills: {
      tableHeaders: [
        t(`Items.transaction_tab_options.date`),
        t(`Items.transaction_tab_options.bill_no`),
        t(`Items.transaction_tab_options.vendor`),
        t(`Items.transaction_tab_options.qty`),
        t(`Items.transaction_tab_options.amount`),
        t(`Items.transaction_tab_options.status`),
      ],
      tableData: [
        'bill_date',
        'bill_no',
        'vendor_name',
        'quantity',
        'total',
        'status',
      ],
      rightAlignColumns: [4, 5, 6],
      linkTo: { path: '/bills/', linkedColumn: 'bill_no' },
    },
    credit_notes: {
      tableHeaders: [
        t(`Items.transaction_tab_options.date`),
        t(`Items.transaction_tab_options.credit_note_no`),
        t(`Items.transaction_tab_options.customer_name`),
        t(`Items.transaction_tab_options.deduction`),
        t(`Items.transaction_tab_options.status`),
      ],
      tableData: [
        'credit_note_date',
        'credit_note_no',
        'contact_name',
        'adjustment_amount',
        'status',
      ],
      rightAlignColumns: [4, 5],
      linkTo: { path: '/creditnotes/', linkedColumn: 'credit_note_no' },
    },
    sales_returns: {
      tableHeaders: [
        t(`Items.transaction_tab_options.date`),
        t(`Items.transaction_tab_options.sales_return_no`),
        t(`Items.transaction_tab_options.customer_name`),
        t(`Items.transaction_tab_options.qty`),
        t(`Items.transaction_tab_options.status`),
      ],
      tableData: [
        'return_date',
        'sales_return_no',
        'contact_name',
        'return_quantity',
        'status',
      ],
      rightAlignColumns: [4, 5],
      linkTo: { path: '/salesreturns/', linkedColumn: 'sales_return_no' },
    },
  };
  filterOptions = []; // options available for current contact depending on item type
  filterStatusOptions = []; // options available for current contact depending on item type
  state = {
    loading: true,
    loadingList: true,
    loadingMore: false,
    activeTab: 'sales_orders',
    activeStatus: 'all',
    list: [],
    currency: {},
    pageNumber: 1,
    viewPerPage: 15,
  };

  componentDidMount() {
    this.getFilerOptions();
    // this.getStatusFilerOptions('sales_orders')
    this.setState({ loading: false });
  }

  getFilerOptions() {
    let options = [];
    this.updateFilter('sales_orders');
    options = [
      {
        id: 'sales_orders',
        label: this.props.t('Items.sales_orders'),
        onClick: () => {
          this.updateFilter('sales_orders');
        },
      },
      {
        id: 'purchase_orders',
        label: this.props.t('Items.purchase_orders'),
        onClick: () => {
          this.updateFilter('purchase_orders');
        },
      },
      {
        id: 'invoices',
        label: this.props.t('Items.invoices'),
        onClick: () => {
          this.updateFilter('invoices');
        },
      },
      {
        id: 'bills',
        label: this.props.t('Items.bills'),
        onClick: () => {
          this.updateFilter('bills');
        },
      },
      {
        id: 'sales_returns',
        label: this.props.t('Items.sales_returns'),
        onClick: () => {
          this.updateFilter('sales_returns');
        },
      },
      {
        id: 'credit_notes',
        label: this.props.t('Items.credit_notes'),
        onClick: () => {
          this.updateFilter('credit_notes');
        },
      },
    ];
    this.filterOptions.push(...options);
  }

  getStatusFilerOptions(filter) {
    let Statusoptions = [];
    this.filterStatusOptions = [];
    // this.updateStatusFilter('all')
    // console.log('filter',filter)

    switch (filter) {
      case 'sales_orders':
        Statusoptions = [
          {
            id: 'all',
            label: this.props.t('Items.all'),
            onClick: () => {
              this.updateStatusFilter('all');
            },
          },
          {
            id: 'draft',
            label: this.props.t('Items.draft'),
            onClick: () => {
              this.updateStatusFilter('draft');
            },
          },
          {
            id: 'closed',
            label: this.props.t('Items.closed'),
            onClick: () => {
              this.updateStatusFilter('closed');
            },
          },
          {
            id: 'confirmed',
            label: this.props.t('Items.confirmed'),
            onClick: () => {
              this.updateStatusFilter('confirmed');
            },
          },
        ];
        break;
      case 'invoices':
        Statusoptions = [
          {
            id: 'all',
            label: this.props.t('Items.all'),
            onClick: () => {
              this.updateStatusFilter('all');
            },
          },
          {
            id: 'paid',
            label: this.props.t('Items.paid'),
            onClick: () => {
              this.updateStatusFilter('paid');
            },
          },
          {
            id: 'overdue',
            label: this.props.t('Items.overdue'),
            onClick: () => {
              this.updateStatusFilter('overdue');
            },
          },
          {
            id: 'draft',
            label: this.props.t('Items.draft'),
            onClick: () => {
              this.updateStatusFilter('draft');
            },
          },
          {
            id: 'partially_paid',
            label: this.props.t('Items.partially_paid'),
            onClick: () => {
              this.updateStatusFilter('partially_paid');
            },
          },
          {
            id: 'sent',
            label: this.props.t('Items.sent'),
            onClick: () => {
              this.updateStatusFilter('sent');
            },
          },
        ];
        break;
      case 'purchase_orders':
        Statusoptions = [
          {
            id: 'all',
            label: this.props.t('Items.all'),
            onClick: () => {
              this.updateStatusFilter('all');
            },
          },
          {
            id: 'issued',
            label: this.props.t('Items.issued'),
            onClick: () => {
              this.updateStatusFilter('issued');
            },
          },
          {
            id: 'draft',
            label: this.props.t('Items.draft'),
            onClick: () => {
              this.updateStatusFilter('draft');
            },
          },
          {
            id: 'cancelled',
            label: this.props.t('Items.cancelled'),
            onClick: () => {
              this.updateStatusFilter('cancelled');
            },
          },
          {
            id: 'closed',
            label: this.props.t('Items.closed'),
            onClick: () => {
              this.updateStatusFilter('closed');
            },
          },
        ];
        break;
      case 'bills':
        Statusoptions = [
          {
            id: 'all',
            label: this.props.t('Items.all'),
            onClick: () => {
              this.updateStatusFilter('all');
            },
          },
          {
            id: 'paid',
            label: this.props.t('Items.paid'),
            onClick: () => {
              this.updateStatusFilter('paid');
            },
          },
          {
            id: 'draft',
            label: this.props.t('Items.draft'),
            onClick: () => {
              this.updateStatusFilter('draft');
            },
          },
          {
            id: 'partially_paid',
            label: this.props.t('Items.partially_paid'),
            onClick: () => {
              this.updateStatusFilter('partially_paid');
            },
          },
          {
            id: 'open',
            label: this.props.t('Items.open'),
            onClick: () => {
              this.updateStatusFilter('open');
            },
          },
          {
            id: 'overdue',
            label: this.props.t('Items.overdue'),
            onClick: () => {
              this.updateStatusFilter('overdue');
            },
          },
        ];
        break;
      case 'credit_notes':
        Statusoptions = [
          {
            id: 'all',
            label: this.props.t('Items.all'),
            onClick: () => {
              this.updateStatusFilter('all');
            },
          },
          {
            id: 'draft',
            label: this.props.t('Items.draft'),
            onClick: () => {
              this.updateStatusFilter('draft');
            },
          },
          {
            id: 'open',
            label: this.props.t('Items.open'),
            onClick: () => {
              this.updateStatusFilter('open');
            },
          },
          {
            id: 'partially_applied',
            label: this.props.t('Items.partially_applied'),
            onClick: () => {
              this.updateStatusFilter('partially_applied');
            },
          },
          {
            id: 'consumed',
            label: this.props.t('Items.consumed'),
            onClick: () => {
              this.updateStatusFilter('consumed');
            },
          },
        ];
        break;
      case 'sales_returns':
        Statusoptions = [
          {
            id: 'all',
            label: this.props.t('Items.all'),
            onClick: () => {
              this.updateStatusFilter('all');
            },
          },
          {
            id: 'draft',
            label: this.props.t('Items.draft'),
            onClick: () => {
              this.updateStatusFilter('draft');
            },
          },
          {
            id: 'confirmed',
            label: this.props.t('Items.confirmed'),
            onClick: () => {
              this.updateStatusFilter('confirmed');
            },
          },
          {
            id: 'receiving',
            label: this.props.t('Items.receiving'),
            onClick: () => {
              this.updateStatusFilter('receiving');
            },
          },
          {
            id: 'closed',
            label: this.props.t('Items.received'),
            onClick: () => {
              this.updateStatusFilter('closed');
            },
          },
        ];
        break;
      default:
        Statusoptions = [
          {
            id: 'all',
            label: this.props.t('Items.all'),
            onClick: () => {
              this.updateStatusFilter('all');
            },
          },
          {
            id: 'onhold',
            label: this.props.t('Items.onhold'),
            onClick: () => {
              this.updateStatusFilter('onhold');
            },
          },
          {
            id: 'draft',
            label: this.props.t('Items.draft'),
            onClick: () => {
              this.updateStatusFilter('Draft');
            },
          },
          {
            id: 'cancelled',
            label: this.props.t('Items.cancelled'),
            onClick: () => {
              this.updateStatusFilter('cancelled');
            },
          },
          {
            id: 'closed',
            label: this.props.t('Items.closed'),
            onClick: () => {
              this.updateStatusFilter('closed');
            },
          },
          {
            id: 'confirmed',
            label: this.props.t('Items.confirmed'),
            onClick: () => {
              this.updateStatusFilter('confirmed');
            },
          },
        ];
        break;
    }
    this.filterStatusOptions.push(...Statusoptions);
    // console.log('this.filterStatusOptions',this.filterStatusOptions)
  }

  PrepareSsaleOrderTableData = (res) => {
    const transactionDetails = res.transactions?.data.map((item, index) => {
      let total = 0;
      let quantity = 0;
      let price = null;
      item.sales_order_details_for_item_transaction.forEach((element) => {
        total = total + element.amount;
        quantity = quantity + element.quantity;
        // price = price ? price + ',' + element.rate : element.rate;
      });
      return {
        order_date: item.order_date,
        display_name: item.display_name,
        sales_order_no: item.sales_order_no,
        status: item.status,
        total: total && Number(total).toFixed(2),
        quantity: quantity,
        id: item.id,
        // price: price,
      };
    });
    return transactionDetails;
  };

  PreparePOTableData = (res) => {
    const transactionDetails = res.transactions?.data.map((item, index) => {
      let total = 0;
      let quantity = 0;
      let price = null;
      item.purchase_order_item_details.forEach((element) => {
        total = total + element.amount;
        quantity = quantity + element.quantity;
        // price = price ? price + ',' + element.rate : element.rate;
      });
      return {
        order_date: item.order_date,
        vendor_name: item.item_transaction_contact.display_name,
        purchase_order_no: item.purchase_order_no,
        status: item.status,
        total: total,
        quantity: quantity,
        id: item.id,
        // price: price,
      };
    });
    return transactionDetails;
  };

  PrepareINVTableData = (res) => {
    const transactionDetails = res.transactions?.data.map((item, index) => {
      let total = 0;
      let quantity = 0;
      let price = null;
      item.invoice_details.forEach((element) => {
        total = total + element.exchanged_amount;
        quantity = quantity + element.quantity;
        // price = price ? price + ',' + element.rate : element.rate;
      });
      return {
        invoice_date: item.invoice_date,
        customer_name: item.display_name,
        invoice_no: item.invoice_no,
        status: item.status,
        total: item.currency.symbol + total,
        quantity: quantity,
        id: item.id,
        // price: price,
      };
    });
    return transactionDetails;
  };

  PrepareBillsTableData = (res) => {
    const transactionDetails = res.transactions?.data.map((item, index) => {
      let total = 0;
      let quantity = 0;
      let price = null;
      item.bill_item_details.forEach((element) => {
        total = total + element.amount;
        quantity = quantity + element.quantity;
        // price = price ? price + ',' + element.rate : element.rate;
      });
      return {
        bill_date: item.bill_date,
        vendor_name: item.item_transaction_contact.display_name,
        bill_no: item.bill_no,
        status: item.status,
        total: total,
        quantity: quantity,
        id: item.id,
        // price: price,
      };
    });
    return transactionDetails;
  };
  PrepareSRTableData = (res) => {
    const transactionDetails = res.transactions?.data.map((item, index) => {
      let quantity = 0;
      item.sales_return_details.forEach((element) => {
        quantity = quantity + element.quantity;
      });
      return {
        return_date: item.sales_return_date,
        contact_name: item.item_transaction_contact.display_name,
        sales_return_no: item.sales_return_no,
        status: item.status,
        return_quantity: quantity,
        id: item.id,
        // price: price,
      };
    });
    return transactionDetails;
  };

  PrepareCreditNotesTableData = (res) => {
    const transactionDetails = res.transactions?.data.map((item, index) => {
      let amount = 0;
      item.credit_note_details.forEach((element) => {
        amount = amount + Number(element.exchanged_adjustment_amount);
      });
      return {
        credit_note_date: item.sales_credit_note_date,
        contact_name: item.item_transaction_contact.display_name,
        credit_note_no: item.credit_note_no,
        status: item.status,
        adjustment_amount: item?.invoice?.currency?.symbol + amount,
        id: item.id,
      };
    });
    return transactionDetails;
  };

  filterSwitch = (filter, res) => {
    switch (filter) {
      case 'sales_orders':
        return this.PrepareSsaleOrderTableData(res);
      case 'purchase_orders':
        return this.PreparePOTableData(res);
      case 'invoices':
        return this.PrepareINVTableData(res);
      case 'bills':
        return this.PrepareBillsTableData(res);
      case 'sales_returns':
        return this.PrepareSRTableData(res);
      case 'credit_notes':
        return this.PrepareCreditNotesTableData(res);
      default:
        return this.PrepareSsaleOrderTableData(res);
    }
  };

  fetchData(filter, status) {
    this.setState({ loadingList: true });
    const { pageNumber, viewPerPage } = this.state;

    restRequest(
      'get',
      `items/${this.props.itemId}/transaction?filter=${filter}&status=${status}&page=${pageNumber}&view=${viewPerPage}`
    )
      .then((res) => {
        this.setState({
          currency: (filter !== 'invoices') ? res.base_currency : {},
          list: this.filterSwitch(filter, res),
          loadingList: false,
          last_page: res.transactions?.last_page,
        });

        // Scroll to bottom of container
        const objDiv = document.querySelector('.detail_component_inner');
        if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
      });
  }

  fetchLoadMoreData = (filter, status) => {
    this.setState({ loadingMore: true });
    const { pageNumber, viewPerPage } = this.state;
    restRequest(
      'get',
      `items/${this.props.itemId}/transaction?filter=${filter}&status=${status}&page=${pageNumber}&view=${viewPerPage}`
    )
      .then((res) => {
        this.setState({
          list: [...this.state.list, ...this.filterSwitch(filter, res)],
          currency: (filter !== 'invoices') ? res.base_currency : {},
          loadingMore: false,
          last_page: res.transactions.last_page,
        });
        var objDiv = document.querySelector('.detail_component_inner');
        if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
      });
  };

  // rehan
  // optimize code here
  // componentDidUpdate(){}

  updateFilter(filter) {
    this.setState({ activeTab: filter });
    this.setState({ activeStatus: 'all' }); //done by ahsan
    this.getStatusFilerOptions(filter);
    this.setState(
      {
        pageNumber: 1,
      },
      () => {
        this.fetchData(filter, 'all');
      }
    );
  }

  updateStatusFilter(status) {
    this.setState({ activeStatus: status });
    this.setState(
      {
        pageNumber: 1,
      },
      () => {
        this.fetchData(this.state.activeTab, status);
      }
    );
  }

  handlePageChange = () => {
    const { pageNumber, activeTab, activeStatus } = this.state;
    this.setState(
      {
        pageNumber: pageNumber + 1,
      },
      () => {
        this.fetchLoadMoreData(activeTab, activeStatus);
      }
    );
  };

  renderTransactions(tab) {
    const { loadingMore, loadingList, list, pageNumber, last_page } =
      this.state;
    if (loadingList) {
      return <Loader />;
    }
    if (list.length === 0) {
      return <EmptyTable inModal />;
    }
    return (
      <>
        <TransactionsTable
          list={list}
          tableHeaders={this.transactionTable[tab].tableHeaders}
          tableData={this.transactionTable[tab].tableData}
          rightAlignColumns={this.transactionTable[tab].rightAlignColumns}
          linkTo={this.transactionTable[tab].linkTo}
          className="list-table mt_0 items-transaction"
          currencySymbol={this.state.currency.symbol}
        />

        {pageNumber < last_page && (
          <button onClick={this.handlePageChange} className="btn-load-set">
            {loadingMore ? <SmallLoader /> : t('Items.load_more')}
          </button>
        )}
      </>
    );
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }
    let currentTab = this.filterOptions.find(
      (obj) => obj.id === this.state.activeTab
    );
    let currentStatusTab = this.filterStatusOptions.find(
      (obj) => obj.id === this.state.activeStatus
    );
    // console.log(currentStatusTab);
    return (
      <div className="contact-transaction sub_tabs_table_transaction">
        <div className="contact-transaction--header padding--regular-horizontal">
          <span className="section-header--dropdown">
            {/* Because of New design */}
            {/* <span className="section-header--dropdown-title">Filter: </span> */}
            <Dropdown
              textLabel={currentTab.label}
              options={this.filterOptions}
            />
          </span>

          <div className="contact-transaction--filter">
            {/* <div className="contact-transaction--dropdown-title semi-bold">Status: </div> */}
            <Dropdown
              textLabel={
                `${this.props.t('Items.status')}: ` + currentStatusTab.label
              }
              options={this.filterStatusOptions}
            />
          </div>
        </div>
        {this.renderTransactions(this.state.activeTab)}
      </div>
    );
  }
}

export default withTranslation()(ItemTransactionTab);
